import { Row, Col, PageHeader, Tag } from "antd";
import { getComponentList } from "Components/Report/OnDemand/chartsList/ChartsList";
import { DeviceValues, deviceOptions } from "../Filter";
// import CompanyMainLogo from "image/CompanyMainLogo.png";
import styles from "Components/Report/report.module.scss";
import { useAppDispatch, useAppSelector } from "store/hook";
import { useReportStatistic } from "Components/Report/queries";
import { PrintHeaderFooter } from "./PrintCover";
import DeviceStatusIdentiy from "./DeviceStaus";
import { useEffect } from "react";
import { setIsFetchingAPI } from "Components/Report/reportSlice";

const DeviceCharts = ({ device, parameter }: { device: string[]; parameter: DeviceValues[] }) => {
  const { preference, filterForm, onViewingDevice, onViewingDevice_Period } = useAppSelector((status) => status.report);
  const { loginCid, stateCid, level, isDarkMode } = useAppSelector((status) => status.global);
  const disp = useAppDispatch();

  const { data: reportStatistic, isFetching } = useReportStatistic(
    { ...filterForm, device_device: [...(filterForm.device_device || []), ...device], ...onViewingDevice_Period },
    loginCid,
    stateCid,
    level
  );

  useEffect(() => {
    disp(setIsFetchingAPI(isFetching));
  }, [isFetching]);

  const data = reportStatistic?.response?.device_level;
  const column = preference["column"]["device"] === 2 ? 12 : 24;
  const order = preference["order"]["device"];

  const orderedParameter = order.map((arr) => arr.filter((p) => parameter.includes(p)));
  const paraNumber = parameter.length;
  return (
    <>
      {device.map((id, dind) => (
        <div key={dind}>
          {!Boolean(onViewingDevice) && (
            <div
              className={styles.unPrint}
              style={{ padding: "12px", backgroundColor: isDarkMode ? "gray" : "#f5f5f5", marginTop: "1rem" }}
            >
              <PageHeader
                ghost={false}
                title={`Device: ${id}`}
                subTitle={`Model: ${data?.[id]?.model || ""} `}
                extra={<DeviceStatusIdentiy id={id} />}
              >
                {filterForm.device_parameter?.map((param, index) => {
                  const option = deviceOptions.find((opt) => opt.value === param);
                  return <Tag key={index}>{option?.label}</Tag>;
                })}
              </PageHeader>
            </div>
          )}
          <Row gutter={24} key={`${id}_${dind}`}>
            {orderedParameter.map((col, ind) => (
              <Col sm={24} md={24} lg={column} xl={column} key={`${id}_${ind}`}>
                <PrintHeaderFooter>
                  {col.map((param, index) => {
                    const newIndex = ind === 0 ? index : index + orderedParameter[0].length;
                    return (
                      <div key={newIndex}>
                        <div
                          key={`${id}_${param}`}
                          className={[
                            styles.elementHeight,
                            styles.noBreak,
                            newIndex % 2 === 1 ? styles.breakAfter : "",
                          ].join(" ")}
                        >
                          {
                            getComponentList({
                              param,
                              data: data?.[id]?.status,
                              id,
                              isFetching,
                              name: data?.[id]?.name,
                            }).find((item) => item.value.includes(param))?.component
                          }

                          {Boolean(newIndex % 2 === 1) && (
                            <h2
                              className={[
                                newIndex + 1 === paraNumber && paraNumber % 2 === 1 ? styles.h2Height : "",
                              ].join(" ")}
                            ></h2>
                          )}
                        </div>
                        {Boolean(newIndex + 1 === paraNumber && paraNumber % 2 === 1) && (
                          <div className={styles.elementHeight}>
                            <h2></h2>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </PrintHeaderFooter>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </>
  );
};

export default DeviceCharts;
